import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/LIB_vehicleinventory'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LIB_vehicleinventoryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LIB_vehicleinventoryStore",
			variables: false,
		})
	}
}

export async function load_LIB_vehicleinventory(params) {
  await initClient()

	const store = new LIB_vehicleinventoryStore()

	await store.fetch(params)

	return {
		LIB_vehicleinventory: store,
	}
}
